import React from 'react';
import Detection from './Detection';
import { LPRParamList } from '../../../typings/Params';
import { useRoute, RouteProp } from '@react-navigation/native';
import { RootNavigation } from '../../../Routes';


interface DetectionProps {
    navigation: RootNavigation;
}

export default function LiveAlertLprDetection({ navigation }: DetectionProps) {
    const route = useRoute<RouteProp<LPRParamList, 'LiveAlertLprDetection'>>();
    return <Detection navigation={navigation} route={route} page={'live-alerts'} />;
}
